import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'irembogov-form-model-preview',
  templateUrl: './irembogov-form-model-preview.component.html',
  styleUrls: ['./irembogov-form-model-preview.component.scss'],
})
export class IrembogovFormModelPreviewComponent {
  @Input() data: any;
}
